module.exports = __webpack_public_path__ + "img/t3-assurance-vie.94abc718.jpg";